import DetailsCardThreeColumnRow from "@/components/DetailsCardThreeColumnRow";
import { CardSkeleton, MetricListItemGridSkeleton, SectionHeadingSkeleton } from "@/components/Skeleton";

export default function CareerGoalsTabSkeleton() {
  return (
    <div className="flex flex-col gap-6" data-testid="career-plan-goals-tab-skeleton">
      <SectionHeadingSkeleton />
      <div className="flex min-w-0 w-full flex-col gap-6">
        <MetricListItemGridSkeleton className="-mt-2" />
        <DetailsCardThreeColumnRow>
          <CardSkeleton className="h-full w-full" width={100} rows={4} />
          <CardSkeleton className="h-full w-full" width={100} rows={4} />
          <CardSkeleton className="h-full w-full" width={100} rows={4} />
        </DetailsCardThreeColumnRow>
      </div>
    </div>
  );
}
